import Button from '@/components/Buttons/Button';
import IconButton from '@/components/Buttons/IconButton';
import WarningColored from '@/images/WarningColored.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog } from '@mui/material';
import { ReactNode } from 'react';

const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        width: 452px;
        padding: 24px 30px;
        font-family: 'Manrope', sans-serif;
        color: ${theme.colors.black[800]};
        gap: 16px;
    }
`;

const Text = styled.div`
    color: ${theme.colors.secondary[900]};
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.15px;
`;

const StyledButton = styled(Button)`
    font-size: 16px;
    font-weight: 600;
    line-height: 24px; /* 150% */
    text-transform: none;

    border-radius: 8px;
    width: 100%;
    height: 44px;
`;

const TitleWithImg = styled.div`
    display: flex;
    align-items: center;
`;

const Buttons = styled.div`
    display: flex;
    gap: 8px;
`;

const Title = styled.h2`
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.48px;
    margin: 0 0 0 10px;
`;

const DeleteCloseButton = styled(IconButton)`
    color: ${theme.colors.black[800]};
    padding: 10px;
    position: absolute;
    right: 6px;
    top: 6px;

    svg {
        width: 18px;
        height: 18px;
    }
`;

export interface ConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onSecondaryClick: () => void;
    onConfirm: () => void;
    title?: ReactNode;
    text?: ReactNode;
    primaryButtonText?: string;
    secondaryButtonText?: string;
    isLoading?: boolean;
}

const ConfirmationModal = ({
    open,
    onClose,
    onSecondaryClick,
    onConfirm,
    title,
    text,
    primaryButtonText,
    secondaryButtonText,
    isLoading,
}: ConfirmationModalProps) => {
    return (
        <StyledDialog open={open}>
            <div>
                <TitleWithImg>
                    <img src={WarningColored} />
                    <Title>{title}</Title>
                </TitleWithImg>
                <DeleteCloseButton ariaLabel="close" onClick={onClose}>
                    <CloseIcon />
                </DeleteCloseButton>
            </div>
            <Text>{text}</Text>
            <Buttons>
                <StyledButton disabled={isLoading} onClick={onSecondaryClick} variant="outlined" color="secondary">
                    {secondaryButtonText}
                </StyledButton>
                <StyledButton disabled={isLoading} onClick={onConfirm} variant="contained" color="secondary">
                    {primaryButtonText}
                </StyledButton>
            </Buttons>
        </StyledDialog>
    );
};

export default ConfirmationModal;
